/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import {
    FormProvider, useFieldArray, useForm, useWatch,
} from "react-hook-form";
import { TableCell, TableRow } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import dayjs from "dayjs";
import { format, isValid as dateIsValid } from "date-fns";
import PTMButton from "../PTMButton";
// eslint-disable-next-line import/no-cycle
import InputSelector from "./InputSelector";
import DropDownContent from "./DropDownContent";
import PTMInput from "../PTMInput";

export default function PTMEditTableEntry(props) {
    const {
        element,
        isActive,
        columns,
        saveHandler,
        removeHandler,
        restoreHandler,
        expandHandler,
        dropdownContent,
        shortWidth,
        customActionButtons,
        draggableProps,
        excludedActions,
        disabledActions,
        addToIsDirtyArray,
        removeFromIsDirtyArray,
        selectable,
        selectHandler,
        selectedEntries,
        lockedProp,
        lockedValue,
        actionControls,
        canDeleteInactive,
        setEditCount,
        i,
        customActionButtonsPosition = "start",
    } = props;

    const [dynamicProps, setDynamicProps] = useState({

    });

    const dynamicPropSetter = (propName, value) => {
        let enterValue = value;

        if (propName === "startDate") {
            enterValue = dayjs(enterValue).add(15, "minute");
        } else if (propName === "endDate") {
            enterValue = dayjs(enterValue).subtract(15, "minute");
        }

        const newProps = { ...dynamicProps };
        newProps[propName] = enterValue;
        setDynamicProps(newProps);
    };

    const dynamicPropGetter = (propName) => {
        if (propName) {
            return dynamicProps[propName];
        }
    };

    const [isEdit, setIsEdit] = useState(element.is_new);

    const [entry, setEntry] = useState(element);

    const [expand, setExpand] = useState(false);

    const [showError, setShowError] = useState(false);

    const createObjectForm = (data) => {
        const objectForm = {};
        columns.forEach((column) => {
            const {
                dataName, fallbackDataName, initialValue, textType, type,
            } = column;
            if (type === "autocompleteAsync") {
                objectForm[dataName] = data[dataName];
            } else if (textType === "decimal") {
                objectForm[dataName] = data[dataName] || 0;
            } else if (column?.dateFormat && data[dataName] && dateIsValid(data[dataName])) {
                objectForm[dataName] = format(new Date(data[dataName]), column?.dateFormat);
            } else if (initialValue === null) {
                objectForm[dataName] = data[dataName] || null;
            } else if (initialValue === undefined) {
                objectForm[dataName] = data[dataName] || undefined;
            } else if (initialValue === 0) {
                objectForm[dataName] = data[dataName] || 0;
            } else {
                objectForm[dataName] = data[dataName] || "";
            }
        });
        objectForm.id = data.id;
        objectForm.is_new = data.is_new;
        objectForm.tmpId = data.tmpId;
        return objectForm;
    };

    const {
        control,
        reset,
        handleSubmit,
        setValue,
        getValues,
        setError,
        formState: {
            errors,
            isDirty,
            isValid,
            dirtyFields,
        },
    } = useForm({
        mode: "onChange",
        defaultValues: createObjectForm(entry),
    });

    const actionsController = {

        save: () => {
            handleSubmit(async (payload) => {
                const newPayload = { ...payload };
                const response = await saveHandler(newPayload, dirtyFields);
                const callbackData = response?.callbackData;
                const callbackFunction = response?.callbackFunction;

                if (callbackData === "taken") {
                    setShowError(true);
                    setTimeout(() => {
                        setShowError(false);
                    }, 4000);
                } else {
                    if (getValues("is_new")) {
                        setValue("is_new", false);
                        setValue("id", callbackData);
                        newPayload.id = callbackData || newPayload.id;
                        delete newPayload.tmp_id;
                        delete newPayload.tmpId;
                    }
                    setEntry(newPayload);
                    reset(createObjectForm(newPayload));
                    setIsEdit(false);
                    if (setEditCount) {
                        setEditCount((prev) => prev - 1);
                    }
                    if (callbackFunction) {
                        callbackFunction();
                    }
                }
            })();
        },
        restore: () => {
            restoreHandler(entry, i);
        },
        discard: () => {
            setIsEdit(false);
            reset(createObjectForm(entry));
            if (setEditCount) {
                setEditCount((prev) => prev - 1);
            }
        },
        edit: () => {
            setIsEdit(true);
            if (setEditCount) {
                setEditCount((prev) => prev + 1);
            }
        },
        remove: () => {
            removeHandler.action(entry, i);
            if (setEditCount && isEdit && entry.is_new) {
                setEditCount((prev) => prev - 1);
            }
            if (removeFromIsDirtyArray) removeFromIsDirtyArray(getValues("id"));
        },
        expand: () => {
            setExpand(!expand);
        },

    };

    const clickHandler = (action, method) => {
        actionsController[action]();
        if (method) method();
    };
    React.useEffect(() => {
        setEntry(element);
    }, [element]);

    React.useEffect(() => {
        if (isDirty) {
            if (addToIsDirtyArray) addToIsDirtyArray(getValues("id"));
        } else if (removeFromIsDirtyArray) removeFromIsDirtyArray(getValues("id"));
    }, [isDirty]);

    const checkIfSelected = (sEntry) => {
        if (selectedEntries?.includes(sEntry?.id)) return "rgba(69,148,173,0.5) !important";
    };

    const checkIfLocked = (sEntry) => {
        if (!lockedProp) return;
        if (sEntry[lockedProp] === lockedValue) return "rgb(248, 148, 6) !important";
    };

    const actionControlsHandler = (sEntry, actionType, actionPerform) => {
        if (!actionControls) return;
        const selectedControl = actionControls.find((sControl) => sControl.type === actionType && sControl.perform === actionPerform);
        if (selectedControl.condition === "prop") {
            if (sEntry[selectedControl.propName] === selectedControl.propValue) {
                return true;
            }
        }
    };

    return (
        <>
            <FormProvider control={control}>
                {selectable && (
                    <TableCell>
                        <PTMInput
                            type="checkbox"
                            value={selectedEntries?.includes(entry?.id)}
                            // checked={selectedEntries.includes(entry?.id)}
                            onChange={(e) => selectHandler(entry?.id, e.target.checked)}
                        />
                    </TableCell>
                )}
                <TableCell>
                    <div style={{ display: "flex", alignItems: "center" }}>
                        {isActive || entry?.is_new ? (
                            <>
                                {customActionButtons && customActionButtonsPosition === "start" && customActionButtons(element, {}, i, isEdit, setIsEdit, getValues())}
                                {!removeHandler.hide && !excludedActions?.includes("remove") && (
                                    <PTMButton
                                        variant="contained"
                                        disabled={
                                            removeHandler?.disable(entry)
                                                    || disabledActions?.includes("remove")
                                                    || actionControlsHandler(entry, "remove", "disable")
                                        }
                                        disabledPopover={removeHandler?.disabledPopover}
                                        popover="Entfernen"
                                        color="error"
                                        sx={{ height: "100%", marginRight: "2px", padding: "6px 9px" }}
                                        onClick={actionsController.remove}
                                    >
                                        <FontAwesomeIcon icon="times" />
                                    </PTMButton>
                                )}
                                {!excludedActions?.includes("edit")
                                            && (
                                                <PTMButton
                                                    variant="contained"
                                                    popover="Bearbeiten"
                                                    disabled={isEdit || disabledActions?.includes("edit") || actionControlsHandler(entry, "edit", "disable")}
                                                    sx={{
                                                        height: "100%", marginRight: "2px", padding: "6px 7px",
                                                    }}
                                                    onClick={actionsController.edit}
                                                >
                                                    <FontAwesomeIcon icon="pen" />
                                                </PTMButton>
                                            )}
                                {!excludedActions?.includes("restore")
                                            && (
                                                <PTMButton
                                                    variant="contained"
                                                    popover="Verwerfen"
                                                    disabled={!isEdit}
                                                    color="warning"
                                                    sx={{
                                                        height: "100%", marginRight: "2px", padding: "6px 7px",
                                                    }}
                                                    onClick={element.is_new ? actionsController.remove : actionsController.discard}
                                                >
                                                    <FontAwesomeIcon icon="redo-alt" />
                                                </PTMButton>
                                            )}
                                {!excludedActions?.includes("save")
                                            && (
                                                <PTMButton
                                                    variant="contained"
                                                    popover="Speichern"
                                                    disabled={!isEdit || !isValid || !isDirty}
                                                    color="success"
                                                    sx={{
                                                        height: "100%", marginRight: "2px", padding: "6px 8px",
                                                    }}
                                                    onClick={actionsController.save}
                                                >
                                                    <FontAwesomeIcon icon="save" />
                                                </PTMButton>
                                            )}
                                {expandHandler && (
                                    <PTMButton
                                        variant="contained"
                                        disabledPopover={removeHandler?.disabledPopover}
                                        popover={`Kontakte ${expand ? "ausblenden" : "anzeigen"}`}
                                        color={expand ? "warning" : "success"}
                                        sx={{ height: "100%", marginRight: "2px", padding: "6px 7px" }}
                                        onClick={actionsController.expand}
                                    >
                                        <FontAwesomeIcon icon={expand ? "chevron-up" : "chevron-down"} />
                                    </PTMButton>
                                )}
                                {customActionButtons && customActionButtonsPosition === "end" && customActionButtons(element, {}, i, isEdit, setIsEdit, getValues())}
                            </>
                        ) : (
                            <>
                                <PTMButton
                                    variant="contained"
                                    popover="Wiederherstellen"
                                    color="warning"
                                    sx={{
                                        height: "100%", marginRight: "2px", padding: "6px 8px",
                                    }}
                                    onClick={actionsController?.restore}
                                >
                                    <FontAwesomeIcon icon="redo-alt" />
                                </PTMButton>
                                {canDeleteInactive && (
                                    <PTMButton
                                        variant="contained"
                                        popover="Entfernen"
                                        color="error"
                                        sx={{
                                            height: "100%", marginRight: "2px", padding: "6px 8px",
                                        }}
                                        onClick={actionsController?.remove}
                                    >
                                        <FontAwesomeIcon icon="times" />
                                    </PTMButton>
                                )}
                                {customActionButtons && customActionButtons(element, { restoreActions: true })}
                            </>
                        )}
                    </div>
                </TableCell>
                <>
                    {columns.filter((column) => !column.hideField).map((column) => (
                        // eslint-disable-next-line react/jsx-no-useless-fragment
                        <React.Fragment key={column.name}>
                            <TableCell
                                onClick={isEdit || !column.click ? null : () => column?.click(entry)}
                                sx={column.sx}
                            >
                                {!(column.onlyOnEdit && !isEdit) && (
                                    <InputSelector
                                        column={column}
                                        getValues={getValues}
                                        setValue={setValue}
                                        setError={setError}
                                        errors={errors}
                                        isEdit={isEdit}
                                        entry={entry}
                                        lockedProp={lockedProp}
                                        lockedValue={lockedValue}
                                        dynamicPropSetter={dynamicPropSetter}
                                        dynamicPropGetter={dynamicPropGetter}
                                        dynamicProps={dynamicProps}
                                    />
                                )}
                            </TableCell>
                        </React.Fragment>
                    ))}
                    {shortWidth && <TableCell /> }
                </>
            </FormProvider>
            { expandHandler && (expand || showError)
                && (
                    <DropDownContent span={columns.length} error={showError}>
                        {dropdownContent(element)}
                    </DropDownContent>
                )}
        </>
    );
}
